<template>
  <div class="page talron main-page">
    <!-- כותרת -->
   
    <layout-process :title="translate('talron.warrantyActivation.optionsTitle')">
      
      <div class="content">

        <!-- טופס -->
        <div v-if="!hideContent" class="form-wrapper uk-width-1-1 ">
          <div  class="uk-text-muted tr-font-small uk-margin-top" role="status" aria-live="polite">
              {{ translate('talron.warrantyActivation.privacyNote1') }}
            </div>
          <!-- שאלה 1: תעודת אחריות -->
          <section class="question-block" aria-labelledby="cert-method-label">
            <div id="cert-method-label" class="uk-text-bold tr-font-s">
              {{ translate('talron.warrantyActivation.askWarrantyCertificate') }}
            </div>

            <div class="uk-margin-small-top uk-grid-small uk-child-width-auto" uk-grid>
              <label>
                <input type="radio" name="wantCertificate" value="yes" v-model="form.wantCertificate"
                  @change="onCertificateChange" :aria-checked="form.wantCertificate === 'yes'" /> 
                {{ translate('talron.general.yes') }}
              </label>

              <label>
                <input type="radio" name="wantCertificate" value="no" v-model="form.wantCertificate"
                  @change="onCertificateChange" :aria-checked="form.wantCertificate === 'no'" /> 
                {{ translate('talron.general.no') }}
              </label>
            </div>

            <!-- הסבר נוסף שמופיע אם נבחר "כן" -->
            <div v-if="form.wantCertificate === 'yes'" class="uk-text-muted tr-font-small uk-margin-top" role="status" aria-live="polite">
              {{ translate('talron.warrantyActivation.note') }}
            </div>

            <!-- שדות תעודה אם נבחר "כן" -->
            <div v-if="form.wantCertificate === 'yes'" class="certificate-fields uk-margin-top">
              <p class="uk-text-bold tr-font-small uk-margin-small-bottom uk-margin-remove-top" role="note">
                {{ translate('talron.warrantyActivation.certificateAtLeastOneIntro') }}
              </p>
              <div class="wrapField">
                <label class="uk-display-block uk-margin-small-bottom" for="smsField">
                  {{ translate('talron.warrantyActivation.certificateSms') }}
                </label>
                <div class="wrapInput">
                  <input id="smsField" type="tel" v-model.trim="form.sms" class="uk-input"
                    :class="{ 'uk-form-danger': errors.sms }"
                    @blur="validatePhoneField"
                    @input="clearFieldError('sms')"
                  />
                  <div v-if="errors.sms" class="uk-text-danger tr-font-small">{{ errors.sms }}</div>
                </div>
              </div>

              <div class="wrapField">
                <label class="uk-display-block uk-margin-small-top" for="emailField">
                  {{ translate('talron.warrantyActivation.certificateEmail') }}
                </label>
                <div class="wrapInput">
                  <input id="emailField" type="email" v-model.trim="form.email" class="uk-input"
                    :class="{ 'uk-form-danger': errors.email }"
                    @blur="validateEmailField"
                    @input="clearFieldError('email')"
                  />
                  <div v-if="errors.email" class="uk-text-danger tr-font-small">{{ errors.email }}</div>
                </div>
              </div>

              <div v-if="errors.atLeastOne" class="uk-text-danger tr-font-small uk-margin-top" role="alert">
                {{ errors.atLeastOne }}
              </div>
            </div>
            <div v-if="errors.wantCertificate" class="uk-text-danger tr-font-small uk-margin-top" role="alert">
              {{ errors.wantCertificate }}
            </div>
          </section>

          <!-- שאלה 2: מצבר חלופי -->
          <section v-if="isAutomaticOrderAllowed" class="question-block uk-margin-large-top"
            aria-labelledby="swap-label">
            <div id="swap-label" class="uk-text-bold tr-font-s">
              {{ translate('talron.warrantyActivation.askAlternateBattery') }}
            </div>

            <div class="uk-margin-small-top uk-grid-small uk-child-width-auto" uk-grid>
              <label>
                <input type="radio" name="wantSwap" value="yes" v-model="form.wantSwap"
                  @change="clearFieldError('wantSwap')" :aria-checked="form.wantSwap === 'yes'" /> 
                {{ translate('talron.general.yes') }}
              </label>

              <label>
                <input type="radio" name="wantSwap" value="no" v-model="form.wantSwap"
                  @change="clearFieldError('wantSwap')" :aria-checked="form.wantSwap === 'no'" /> 
                {{ translate('talron.general.no') }}
              </label>
            </div>

            <div v-if="errors.wantSwap" class="uk-text-danger tr-font-small uk-margin-top" role="alert">
              {{ errors.wantSwap }}
            </div>
          </section>

          <div v-if="submitResult.status === 'error'" class="uk-text-center uk-padding">
            <div class="uk-alert-danger" uk-alert>
              <p>{{ submitResult.message }}</p>
            </div>
          </div>
            <div  class="uk-text-muted tr-font-small uk-margin-top" role="status" aria-live="polite">
              {{ translate('talron.warrantyActivation.privacyNote2') }}
            </div>
          <!-- כפתור המשך -->
          <div class="uk-margin-large-top uk-flex uk-flex-center">
            <form-button :disabled="isSubmitting" @click.prevent="onContinue">
              {{ translate('talron.warrantyActivation.continue') }}
            </form-button>
          </div>
        </div>
        <!-- תוצאה API -->
       <div v-if="submitResult.status === 'success'" class="uk-text-center uk-padding">
        <div class="image-block uk-flex uk-flex-center" style="margin-bottom: 8px;">
          <img :src="getDynamicAssetUrl('images/warrany-activation.png')" alt=""  style="height: 47px; width: auto;margin: 0 auto;"/>
      </div>
         <div class="tr-font-title uk-text-success" >
           <p>{{ submitResult.message }}</p>
           <p v-if="isAutomaticOrderAllowed" class="success-text-small">{{ translate('talron.warrantyActivation.orderReceived') }}</p>

         </div>
         <!-- <action-button class="uk-margin-top" @click="$emit('continue')">
           חזרה לפעולות
         </action-button> -->
         <button-group class="back-button-gruop uk-flex uk-flex-center" style="margin-top:30px">
          <form-button @click.prevent="$router.push({name: 'index'})">{{translate('talron.replace.external.backHomeButtonCta')}}</form-button>
      </button-group>

       </div>
      </div>
    </layout-process>
  </div>
</template>

<script>
  import { computed, reactive, ref } from 'vue';
  import { useStore } from 'vuex';
  import asyncOperations from '@/client/extensions/composition/asyncOperations';
  
  export default {
    name: 'warranty-and-swap',
    emits: ['continue'],
  
    setup(props, { emit }) {
      const store = useStore();
      const { asyncOps } = asyncOperations(props, store);
  
      const form = reactive({
        wantCertificate: null,
        sms: '',
        email: '',
        wantSwap: null,
      });


      const isAutomaticOrderAllowed = computed(() => store.state.talron.isAutomaticOrderAllowed);
      const errors = reactive({
        sms: '',
        email: '',
        atLeastOne: '',
        wantSwap: '',
        wantCertificate: '',
      });
  
      const submitResult = reactive({
        status: null, // 'success' | 'error'
        message: '',
      });
  
      const isSubmitting = ref(false);
      const hideContent = ref(false);

      /* -----------------
       ולידציות שדה (blur)
      ------------------ */
  
      function validatePhoneField() {
        if (!form.sms) return;
  
        const value = form.sms.replace(/[\s-]/g, '');
        const phoneRegex = /^05\d{8}$/;
  
        if (!phoneRegex.test(value)) {
          errors.sms = 'מספר טלפון לא תקין';
        }
      }
  
      function validateEmailField() {
        if (!form.email) return;
  
        if (form.email.length < 5) {
          errors.email = 'כתובת מייל קצרה מדי';
          return;
        }
  
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(form.email)) {
          errors.email = 'כתובת מייל לא תקינה';
        }
      }
  
      function clearFieldError(field) {
        errors[field] = '';
        if (field === 'sms' || field === 'email') {
          errors.atLeastOne = '';
        }
      }
  
      function onCertificateChange() {
        clearFieldError('wantCertificate');
        if (form.wantCertificate !== 'yes') {
          form.sms = '';
          form.email = '';
          errors.sms = '';
          errors.email = '';
          errors.atLeastOne = '';
        }
      }
  
      /* -----------------
         ולידציית טופס
      ------------------ */
  
      function validateForm() {
        let ok = true;
  
        if (isAutomaticOrderAllowed.value) {
          if (form.wantSwap !== 'yes' && form.wantSwap !== 'no') {
            errors.wantSwap = 'יש לבחור תשובה';
            ok = false;
          }
        }
        if (form.wantCertificate !== 'yes' && form.wantCertificate !== 'no') {
            errors.wantCertificate = 'יש לבחור תשובה';
            ok = false;
          }
        if (form.wantCertificate === 'yes') {
          const hasSms = !!form.sms;
          const hasEmail = !!form.email;
  
          if (!hasSms && !hasEmail) {
            errors.atLeastOne = 'חובה למלא טלפון או מייל';
            ok = false;
          }
        }
  
        if (errors.sms || errors.email) {
          ok = false;
        }
  
        return ok;
      }
  
      /* -----------------
           שליחה
      ------------------ */
  
      async function onContinue() {
        if (!validateForm()) return;
        store.commit('ui/showGlobalSpinner', 'נא להמתין, הפעולה מתבצעת...');

        isSubmitting.value = true;
        submitResult.status = null;
        submitResult.message = '';
        
        try {
          const result = await asyncOps.asyncCall(
            'battery/activate',
            {
              ContactId: store.state.talron.user.id,
              SerialNumber: store.state.talron.battery.serialNumber,
              IsWantsWarrantyDocument: form.wantCertificate === 'yes',
              Email: form.email || null,
              PhoneNumber: form.sms || null,
              IsNewBattery:!!(form.wantSwap === 'yes')
            },
            { method: 'patch' }
          );
          store.commit('ui/hideGlobalSpinner');

          if (result?.data?.status === 1) {
            submitResult.status = 'success';
            submitResult.message = 'הפעולה בוצעה בהצלחה';
            hideContent.value=true;
          } else {
            submitResult.status = 'error';
            submitResult.message =
              result?.data?.response?.RejectionReason ||
              'אירעה שגיאה, אנא נסו שוב מאוחר יותר';
          }
        } catch (e) {
          submitResult.status = 'error';
          submitResult.message = ' שגיאת תקשורת, אנא נסו שוב מאוחר יותר';
          console.error(e);
        } finally {
          isSubmitting.value = false;
        }
      }
  
      /* -----------------
         בדיקת זכאות
      ------------------ */
  
  
      return {
        form,
        errors,
        submitResult,
        isSubmitting,
        hideContent,
        isAutomaticOrderAllowed,
        onContinue,
        onCertificateChange,
        clearFieldError,
        validatePhoneField,
        validateEmailField,
      };
    },
  };
  </script>
  

<style lang="scss" scoped>
.content {
  position: relative;
  max-width: 920px;
  margin: 0 auto;
  padding: 20px;
}
.process-title{
  background-image: linear-gradient(93deg, #f2c94c 15%, #f2994a 129%);
  border-radius: var(--border-radius-large) var(--border-radius-large) 0 0;
  display: flex
;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 10px;
  padding: 20px 22px;
  line-height: 1;
  font-weight: bold;
  box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.11);
  cursor: pointer;
  transition: opacity 300ms ease, box-shadow 300ms ease;
}
.form-wrapper {
  background: var(--global-surface, #fff);
  border-radius: 8px;
  padding: 22px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04);
}

.question-block {
  margin-bottom: 20px;
}

.certificate-fields input.uk-input {
  margin-bottom: 6px;
}

.uk-text-danger {
  color: var(--global-danger-color)!important;
} 

.warranty-title {
  text-align: center;
  margin-top: 8px;
}

.wrapField {
  display: flex;
  flex-wrap: wrap;
}

.wrapField label {
  width: 70px;
}
p.success-text-small {
    font-size: 20px;
}
.wrapField input {
  width: 400px;
  max-width: 74%;
}
.wrapInput .uk-text-danger {
  font-size: 12px;
  position: relative;
  display: block;
  background: var(--global-danger-background);
  color: var(--global-color) !important;
  padding: 6px 8px 3px 8px;
  top: -11px;
  z-index: 0;
  border-radius: 0 0 var(--border-radius-small) var(--border-radius-small);
}
label.uk-first-column {
    margin-right: 50px;
}
</style>
